//cspell:ignore vnode, describedby
import { ref, onMounted, getCurrentInstance, Ref } from "vue";
import { focusTrapSetup, FocusTrapOptions } from "@/lib/focusTrapMixin.3";
import delayPromise from "./delayPromise";

export type DialogProps = FocusTrapOptions;

export function dialogSetup(containerRef: Ref<HTMLElement | null>, props?: DialogProps) {
    const focusTrap = focusTrapSetup(containerRef, props);
    const componentInstance = getCurrentInstance();
    const dialogRenderPromise = ref<Promise<void>>(null!);
    const linkModalDescriptionTexts = () => {
        const describedbyElements: HTMLElement[] = Array.from(containerRef.value?.querySelectorAll("[describedby-text]") ?? []);
        if (describedbyElements.length > 0) {
            const describedbyTexts: string[] = [];
            describedbyElements.forEach((elem: HTMLElement, index: number) => {
                const modalDescriptionText = `modal-description-text-${componentInstance?.uid}-${index}`;
                (elem as HTMLElement).setAttribute("id", modalDescriptionText);
                describedbyTexts.push(modalDescriptionText);
            });
            containerRef.value?.closest(".modal")?.setAttribute("aria-describedby", describedbyTexts.join(" "));
        }
    };

    onMounted(async () => {
        containerRef.value?.querySelector(".modal-title")?.setAttribute("id", `modal-header-text-${componentInstance?.uid}`);
        containerRef.value?.closest(".modal")?.setAttribute("aria-labelledby", `modal-header-text-${componentInstance?.uid}`);

        if (dialogRenderPromise.value != null) {
            containerRef.value?.closest(".vfm__content")?.setAttribute("tabindex", "-1");
            // Disable focus trap in order to focus modal container temporarily.
            // This will enable screen readers to properly scan the label and all of its linked descriptions.
            focusTrap.focusTrapSetEnabled(false);
            (containerRef.value?.closest(".vfm__content") as HTMLElement)?.focus();
            await dialogRenderPromise.value;
            await delayPromise(0);
            linkModalDescriptionTexts();
            // Re-enable focus trap.
            focusTrap.focusTrapSetEnabled(true);
        } else {
            linkModalDescriptionTexts();
        }
    });

    return {
        dialogRenderPromise,
        ...focusTrap,
    };
}
